import { useNavigate } from "react-router-dom";
import { Eye, ArrowLeft } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import { Button } from "@/components/ui/button";

export function ImpersonationBanner() {
  const { impersonating, stopImpersonation, user } = useAuth();
  const navigate = useNavigate();
  if (!impersonating || user?.roleType !== "super_admin") return null;

  return (
    <div className="sticky top-0 z-40 flex items-center justify-between gap-3 border-b border-accent/30 bg-gradient-to-r from-accent/15 via-primary/10 to-accent/15 px-4 py-2 text-xs backdrop-blur-md md:px-6">
      <div className="flex items-center gap-2">
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-accent/20">
          <Eye className="h-3.5 w-3.5 text-accent" />
        </div>
        <span className="text-muted-foreground">Viewing tenant</span>
        <span className="font-semibold text-foreground">{impersonating.tenantName}</span>
        <span className="text-muted-foreground">as Super Admin</span>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="h-7 border-accent/40 text-xs hover:bg-accent/10"
        onClick={() => { stopImpersonation(); navigate("/platform/tenants"); }}
      >
        <ArrowLeft className="mr-1.5 h-3 w-3" />
        Return to Platform Console
      </Button>
    </div>
  );
}
